import {
  Book,
  ChevronDown,
  MessageSquare,
  RefreshCw,
  Shield,
  XCircle,
} from "lucide-react";
import React, { useState } from "react";
import Footer from "../Components/Footer";
import Navbar from "../Components/Header";
import blobTopLeft from "../Images/tealback.png";

const AnimatedIcon = ({ icon: Icon }) => (
  <div className="transform transition-all duration-300 hover:scale-125 hover:rotate-180">
    <Icon className="w-6 h-6 text-teal-600" />
  </div>
);

const ExpandableSection = ({ title, content, icon }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="border border-teal-200 rounded-lg overflow-hidden mb-0 transition-all duration-300 ease-in-out">
      <button
        className="w-full px-4 py-5 flex items-center justify-between bg-teal-50 hover:bg-teal-100 transition-colors duration-200"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center space-x-2">
          <AnimatedIcon icon={icon} />
          <h3 className="text-sm  text-teal-800">{title}</h3>
        </div>
        <ChevronDown
          className={`w-5 h-5 text-teal-600 transform transition-transform duration-300`}
        />
      </button>
      <div
        className={`bg-white transition-all duration-300 ease-in-out ${
          isExpanded
            ? "max-h-96 opacity-100 px-4 py-3"
            : "max-h-0 opacity-0 p-0"
        } overflow-hidden`}
      >
        <p className="text-teal-900 px-2 py-4">{content}</p>
      </div>
    </div>
  );
};

const PrivacyPolicy = () => {
  const sections = [
    {
      title: "Information Collection and Use",
      icon: Shield,
      content:
        "While using our website, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. This personally identifiable information may include, but is not limited to, your name, email address, postal address, and phone number.",
    },
    {
      title: "Log Data",
      icon: Book,
      content:
        "Like many site operators, we collect information that your browser sends whenever you visit our site. This log data may include information such as your computer’s Internet Protocol ('IP') address, browser type, browser version, the pages of our site that you visit, the time and date of your visit, the time spent on those pages, and other statistics.",
    },
    {
      title: "Communications",
      icon: MessageSquare,
      content:
        "We may use your personal information to contact you with newsletters, marketing or promotional materials, and other information that you have opted into receiving.",
    },
  ];

  return (
    <div className="space-y-6 animate-fade-in">
      {/* <h2 className="text-3xl font-semibold text-teal-200">Privacy Policy</h2> */}
      <p className="text-white">Last updated: 25-06-2024</p>
      {sections.map((section, index) => (
        <ExpandableSection key={index} {...section} />
      ))}
    </div>
  );
};

const TermsOfService = () => {
  const sections = [
    {
      title: "Agreement to Terms",
      icon: Book,
      content:
        "By accessing or using the Solvexa Marketing website, you agree to be bound by these terms and all applicable laws and regulations. If you disagree with any part of the terms, then you may not access the service.",
    },
    {
      title: "Use of Service",
      icon: Shield,
      content:
        "You agree to use the service only for lawful purposes and in a manner consistent with all applicable local, state, national, and international laws and regulations.",
    },
    {
      title: "Termination",
      icon: XCircle,
      content:
        "We may terminate or suspend access to our service immediately, without prior notice or liability, for any reason whatsoever, including, without limitation, if you breach the Terms.",
    },
    {
      title: "Changes to Terms",
      icon: RefreshCw,
      content:
        "Solvexa Marketing reserves the right to update or modify these Terms at any time without prior notice. Your continued use of the site after any such changes constitutes your acceptance of the new Terms.",
    },
  ];

  return (
    <div className="space-y-6 animate-fade-in">
      {/* <h2 className="text-3xl font-bold text-teal-200">Terms of Service</h2> */}
      <p className="text-white">Last updated: 25-06-2024</p>
      {sections.map((section, index) => (
        <ExpandableSection key={index} {...section} />
      ))}
    </div>
  );
};

const PrivacyTermsPage = () => {
  const [activeTab, setActiveTab] = useState("privacy");

  return (
    <>
      <Navbar />
      <div className=" mx-auto px-4 pt-10 lg:pt-16 lg:pb-8 md:pb-6 pb-4 bg-gradient-to-tr from-teal-950 via-teal-700  to-teal-400 min-h-screen"
        style={{
          backgroundImage: `url(${blobTopLeft})`,
          backgroundSize: "cover",
          backgroundPosition: "top left",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed", // Fix background movement
        }}>
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 text-center text-white bg-clip-text text-transparent bg-gradient-to-r from-teal-100 to-white">
          Privacy Policy & Terms of Service
        </h1>
        <div className="max-w-3xl mx-auto mt-14 ">
          <div className="flex mb-6 gap-x-4 ">
            <button
              className={`flex-1 py-3 px-4 text-center  ${
                activeTab === "privacy"
                  ? "bg-teal-200 bg-opacity-50 text-white"
                  : " text-white"
              }  border border-teal-200 rounded-md transition-colors duration-300`}
              onClick={() => setActiveTab("privacy")}
            >
              <div className="flex items-center justify-center   ">
                <Shield className="w-5 h-5 mr-2 hidden md:block lg:block" />
                <h1 className="font-semibold ">Privacy Policy</h1>
              </div>
            </button>
            <button
              className={`flex-1 py-3 px-4 text-center ${
                activeTab === "terms"
                  ? "bg-teal-200 bg-opacity-50 text-white"
                  : " text-white"
              } border border-teal-200 rounded-md transition-colors duration-300`}
              onClick={() => setActiveTab("terms")}
            >
              <div className="flex items-center justify-center ">
                <Book className="w-5 h-5 mr-2 hidden md:block lg:block" />
                <h1 className="font-semibold">Terms of Service </h1>
              </div>
            </button>
          </div>
          <div className="border-t border-teal-200 pt-2">
            {activeTab === "privacy" ? <PrivacyPolicy /> : <TermsOfService />}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyTermsPage;
